if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.featured = this.dataset.featured;
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      if(document.querySelector('.media-gallery') && document.querySelector('.media-gallery').classList.contains('has_slider')){
          let vertical_slider = document.querySelector('.product-side-images');
          let vertical_slideshow_slides = Array.from(document.querySelectorAll('.product-sub-images'));
          if(document.querySelector('.eam-vertical-slider-active')){
            var posElement = document.querySelector('.eam-vertical-slider-active').offsetTop;
          }
          document.querySelector('.product-side-images').scrollTop = posElement-200;
          let current_variant_id = document.querySelector('.product-form [name="id"]').value;
          let current_variant = this.getVariantData().filter(function(variant){
              if(variant.id == current_variant_id ){
                  return variant
              }
          });
          let full_current_alt,current_alt;
          current_variant = current_variant[0];
          if(current_variant.featured_media){
                full_current_alt = current_variant.featured_media.alt;
                if(full_current_alt!=undefined ){
                  current_alt = current_variant.featured_media.alt.split('_')[1];
                  if(current_alt!=undefined){
                    document.querySelectorAll('.product-sub-images').forEach(function(product_sub_image) {
                      if(product_sub_image.dataset.grpvl != current_alt && product_sub_image.dataset.grpvl != 'eam_all'){
                        product_sub_image.style.display="none";
                      }
                    });
                  }
              }
          }
            let product_slider = new Flickity('#Product-Slider');
            product_slider.destroy();
            
           document.querySelectorAll('.product-images__slide').forEach(function(product_main_image) {
             product_main_image.remove();
           });
           let main_length = 0;
           all_slides.forEach(function(product_main_image) {
              if((product_main_image.dataset.grpvl == current_alt || product_main_image.dataset.grpvl == 'eam_all') && product_main_image.dataset.mediaType != 'video'){
                main_length++
                document.querySelector('#Product-Slider').innerHTML = document.querySelector('#Product-Slider').innerHTML + product_main_image.outerHTML;
              }
           });
            if(main_length==0){
              all_slides.forEach(function(product_main_image) {
                if(product_main_image.dataset.mediaType != 'video') {
                  document.querySelector('#Product-Slider').innerHTML = document.querySelector('#Product-Slider').innerHTML + product_main_image.outerHTML;
                }
              });
            }
            document.querySelectorAll('.product-images__slide').forEach(function(product_main_image) {
                    product_main_image.style.display="block";
                    product_main_image.classList.remove("is-hidden");
            });
            let args = {
              wrapAround: false,
              cellAlign: "left",
              pageDots: true,
               
              contain: true,
              selectedAttraction: 0.3,
              friction: 0.9,
              prevNextButtons: true,
              on: {
                settle: function(index) {
                  if(window.outerWidth>768){
                      
                      let current_media = document.querySelector('.product-images__slide.carousel__slide.is-selected').dataset.mediaId2;
                      document.querySelector('.product-sub-images[data-media-id="'+current_media+'"]').click();
                  }else{
                      let current_media = document.querySelector('.product-images__slide.carousel__slide.is-selected').dataset.mediaId2;
                      document.querySelector('.product-sub-images[data-media-id="'+current_media+'"]').click();
                  }
                }
              }
            };




        
            var $carousel =  new Flickity('#Product-Slider', args)
            if(this.currentVariant && current_alt!=undefined){
                let length = 0;
                document.querySelectorAll('.product-sub-images').forEach(function(product_sub_image) {
                  if(product_sub_image.dataset.grpvl != current_alt && product_sub_image.dataset.grpvl != 'eam_all'){
                    product_sub_image.style.display="none";
                  }else{
                    length++;
                    product_sub_image.style.display="block";
                  }
                });
                if(length==0){
                   document.querySelectorAll('.product-sub-images').forEach(function(product_sub_image) {
                      product_sub_image.style.display="block";
                    });
                }
           }
            let featured_media_id = current_variant.featured_media.id;
            if(document.querySelector('.product-sub-images[data-media-id="'+featured_media_id+'"]')){
              document.querySelector('.product-sub-images[data-media-id="'+featured_media_id+'"]').click();
            }
              document.querySelectorAll('.product-sub-images').forEach(function(vertical_slider) {
                vertical_slider.addEventListener('click',function(params) {
                  if(document.querySelector('.eam-vertical-slider-active')){
                    document.querySelector('.eam-vertical-slider-active').classList.remove('eam-vertical-slider-active');
                  }
                  vertical_slider.classList.add('eam-vertical-slider-active');
                  var posElement = document.querySelector('.eam-vertical-slider-active').offsetTop;
                  document.querySelector('.product-side-images').scrollTop = posElement-200;
                  let index = vertical_slideshow_slides.indexOf(vertical_slider);

                  
                  var posElementX = document.querySelector('.eam-vertical-slider-active').offsetLeft;
                  document.querySelector('.product-side-images').scrollLeft = posElementX - 200;
                  let indexX = vertical_slideshow_slides.indexOf(vertical_slider);
                  
                  let new_index =  Array.from(document.querySelectorAll('.product-images__slide')).indexOf(document.querySelector('.product-images__slide[data-media-id2="'+vertical_slider.dataset.mediaId+'"]'));
                  if(window.outerWidth > 768){
                    $carousel.select(new_index, true,true);
                  }else{
                    $carousel.select(new_index, true,true);
                  }
                })
              });

        }else{
          document.querySelectorAll('.product-images__slide').forEach(function(product_main_image) {
            product_main_image.style.display="block";
            product_main_image.classList.remove("is-hidden");
          });
         let args = {
          wrapAround: false,
          cellAlign: "left",
          pageDots: true,
           
          contain: true,
          selectedAttraction: 0.3,
          friction: 0.9,
          asNavFor: document.querySelector('.product-images__slide'),
          prevNextButtons: true,
          on: {
            settle: function(index) {
              if(window.outerWidth>768){
                let current_media = document.querySelector('.product-images__slide.carousel__slide.is-selected').dataset.mediaId2;
                document.querySelector('.product-sub-images[data-media-id="'+current_media+'"]').click();
              }else{
                let current_media = document.querySelector('.product-images__slide.carousel__slide.is-selected').dataset.mediaId2;
                document.querySelector('.product-sub-images[data-media-id="'+current_media+'"]').click();
              }
            }
          }
        };
        var $carousel =  new Flickity('#Product-Slider', args)
        if(current_variant.featured_media){
          let featured_media_id = current_variant.featured_media.id;
          if(document.querySelector('.product-sub-images[data-media-id="'+featured_media_id+'"]')){
            document.querySelector('.product-sub-images[data-media-id="'+featured_media_id+'"]').click();
          }
            document.querySelectorAll('.product-sub-images').forEach(function(vertical_slider) {
              vertical_slider.addEventListener('click',function(e) {
                e.preventDefault();
                if(document.querySelector('.eam-vertical-slider-active')){
                  document.querySelector('.eam-vertical-slider-active').classList.remove('eam-vertical-slider-active');
                }
                vertical_slider.classList.add('eam-vertical-slider-active');
                var posElement = document.querySelector('.eam-vertical-slider-active').offsetTop;
                document.querySelector('.product-side-images').scrollTop = posElement-200;
                let index = vertical_slideshow_slides.indexOf(vertical_slider);
                  
                  var posElementX = document.querySelector('.eam-vertical-slider-active').offsetLeft;
                  document.querySelector('.product-side-images').scrollLeft = posElementX - 200;
                  let indexX = vertical_slideshow_slides.indexOf(vertical_slider);
                  
                  let new_index =  Array.from(document.querySelectorAll('.product-images__slide')).indexOf(document.querySelector('.product-images__slide[data-media-id2="'+vertical_slider.dataset.mediaId+'"]'));
                
                if(window.outerWidth > 768){
                  $carousel.select(new_index, true, true);
                }else{
                  $carousel.select(new_index, true, true);
                }
              })
            });  
        }
      }
      if(document.querySelector('.product-side-images')){
        document.querySelector('.product-side-images').style.maxHeight=(document.querySelector('.product-image-container .flickity-viewport').clientHeight)+'px';
      }
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setDisabledClass();
    }

    updatetextplug() {
      var plug_text = $('.product-section-2 fieldset.product-form__input.product-form__input--dropdown .select select').val()
      $('.plug_value').text(plug_text);
      

      
      if (document.querySelector('.product-grid-container--main__image')) {
        document.querySelector('.product-grid-container--main__image').style.display = 'none';
        document.querySelector('.media-gallery').style.display = '';
      }
      $(".thb-product-detail").removeClass("thb-product-detail-active");
      
    }
    onVariantChange() {
      if (!this.currentVariant) {
       $('.klaviyo-bis-trigger').show();
      }else{
       $('.klaviyo-bis-trigger').hide();
      }
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled(); 
      this.setDisabledClass();
      this.updateOther();
      this.updatetextplug();
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (!this.featured) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
      const couponContainer = document.querySelector('coupon-container');
      if (couponContainer && couponContainer.resetPriceDom) {
        couponContainer.resetPriceDom();
      }
        //adjustoutofstockVariant();//Only use when have dropdown
    }
    setDisabledClass() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const elementsClass = document.querySelectorAll("variant-selects");
      
      if (this.currentVariant.available){
        submitButtons.forEach((submitButton) => {
          const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
          submitButtonText.textContent = window.theme.variantStrings.addToCart + " · "+ current_currency + (this.currentVariant.price/100).toFixed(2) + " " + currency_iso_code;;
        });
        document.querySelector(".product-add-to-cart-container").classList.remove('is-sold-out'); 
        
        elementsClass.forEach((element) => {
          element.classList.remove('is-sold-out_variations')
        });
        
      }
      else{
        submitButtons.forEach((submitButton) => {
          const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
          submitButtonText.textContent = window.theme.variantStrings.soldOut;
        });
        document.querySelector(".product-add-to-cart-container").classList.add('is-sold-out');
        
        elementsClass.forEach((element) => {
          element.classList.add('is-sold-out_variations')
        });

      }


      // Assuming `this.currentVariant.id` is available in the context
      // Replace `this.currentVariant.id` with the actual way you access the current variant's ID if needed
      
      // Check if elements with the class .whats-in-box--main__image exist
      if (document.querySelector('.whats-in-box--main__image')) {
        // Get all elements with the class .whats-in-box--main__image
        const images = document.querySelectorAll('.whats-in-box--main__image');
        // Iterate over each element
        images.forEach((image) => {
          // Get the variant_id attribute of the current element
          const variantId = image.getAttribute('variant_id');
          // Compare the variant_id with the currentVariant's id
          if (variantId === this.currentVariant.id.toString()) {
            // If they match, add the active class
            image.classList.add('active');
          } else {
            // If they don't match, remove the active class
            image.classList.remove('active');
          }
        });
      }




      var variantId = this.currentVariant.id;
      
      $('.variant-data-hidden').each(function() {
        var elementVariantId = $(this).data('variant-id');
        if (elementVariantId === variantId) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });





      
    }
    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      if(document.querySelector('.media-gallery') && document.querySelector('.media-gallery').classList.contains('has_slider')){
          let full_current_alt = this.currentVariant.featured_media.alt;
          let current_alt = null;
          if(full_current_alt!=undefined){
            current_alt = this.currentVariant.featured_media.alt.split('_')[1];
          }
          let product_slider = new Flickity('#Product-Slider');
          product_slider.destroy();
          
         document.querySelectorAll('.product-images__slide').forEach(function(product_main_image) {
           product_main_image.remove();
         });
        if(this.currentVariant){
          let main_length = 0;
          all_slides.forEach(function(product_main_image) {
              if((product_main_image.dataset.grpvl == current_alt || product_main_image.dataset.grpvl == 'eam_all') && product_main_image.dataset.mediaType != 'video'){
                main_length++;
                document.querySelector('#Product-Slider').innerHTML = document.querySelector('#Product-Slider').innerHTML + product_main_image.outerHTML;
              }
          });
          if(main_length==0){
              all_slides.forEach(function(product_main_image) {
                if(product_main_image.dataset.mediaType != 'video') {
                  document.querySelector('#Product-Slider').innerHTML = document.querySelector('#Product-Slider').innerHTML + product_main_image.outerHTML;
                }
              });
          }
        }
          document.querySelectorAll('.product-images__slide').forEach(function(product_main_image) {
                  product_main_image.style.display="block";
                  product_main_image.classList.remove("is-hidden");
          });
          let args = {
            wrapAround: false,
            cellAlign: "left",
             
            pageDots: true,
            contain: true,
            selectedAttraction: 0.3,
            friction: 0.9,
            prevNextButtons: true,
            on: {
              settle: function(index) {
                if(window.outerWidth>768){
                  let current_media = document.querySelector('.product-images__slide.carousel__slide.is-selected').dataset.mediaId2;
                  document.querySelector('.product-sub-images[data-media-id="'+current_media+'"]').click();
                }else{
                  let current_media = document.querySelector('.product-images__slide.carousel__slide.is-selected').dataset.mediaId2;
                  document.querySelector('.product-sub-images[data-media-id="'+current_media+'"]').click();
                }
              }
            }
          };
          var $carousel =  new Flickity('#Product-Slider', args)
          if(full_current_alt!=undefined   ){
            let length = 0; 
            if(current_alt!=undefined){
              document.querySelectorAll('.product-sub-images').forEach(function(product_sub_image) {
                if(product_sub_image.dataset.grpvl != current_alt && product_sub_image.dataset.grpvl != 'eam_all'){
                  product_sub_image.style.display="none";
                }else{
                  length++;
                  product_sub_image.style.display="block";
                }
              });
              if(length == 0){
                document.querySelectorAll('.product-sub-images').forEach(function(product_sub_image) {
                  product_sub_image.style.display="block";
                });
              }
            }
            let featured_media_id = this.currentVariant.featured_media.id;
            if(document.querySelector('.product-sub-images[data-media-id="'+featured_media_id+'"]')){
              document.querySelector('.product-sub-images[data-media-id="'+featured_media_id+'"]').click();
            }
            var vertical_slideshow_slides = Array.from(document.querySelectorAll('.product-sub-images'));
              document.querySelectorAll('.product-sub-images').forEach(function(vertical_slider) {
                vertical_slider.addEventListener('click',function(params) {
                  if(document.querySelector('.eam-vertical-slider-active')){
                    document.querySelector('.eam-vertical-slider-active').classList.remove('eam-vertical-slider-active');
                  }
                  
                  vertical_slider.classList.add('eam-vertical-slider-active');
                  var posElement = document.querySelector('.eam-vertical-slider-active').offsetTop;
                  document.querySelector('.product-side-images').scrollTop = posElement-200;
                  let index = vertical_slideshow_slides.indexOf(vertical_slider);

                  

                  
                  var posElementX = document.querySelector('.eam-vertical-slider-active').offsetLeft;
                  document.querySelector('.product-side-images').scrollLeft = posElementX - 200;
                  let indexX = vertical_slideshow_slides.indexOf(vertical_slider);
                  let new_index =  Array.from(document.querySelectorAll('.product-images__slide')).indexOf(document.querySelector('.product-images__slide[data-media-id2="'+vertical_slider.dataset.mediaId+'"]'));

                  
                  if(window.outerWidth>768){
                    $carousel.select(new_index, true,true);
                  }else{
                    $carousel.select(new_index, true,true);
                  }
                })
              });
          }
      }else{
        const productSlider = document.getElementById(`MediaGallery-${this.dataset.section}`);
        if (!productSlider) return;
        let mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
        let activeMedia = productSlider.querySelector(`[data-media-id="${ mediaId }"]`);
        if(document.querySelector('.media-gallery') && document.querySelector('.media-gallery').classList.contains('has_slider')){
          document.querySelector('.product-sub-images[data-media-id="'+this.currentVariant.featured_media.id+'"]').click();
        }else{
          productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
            element.classList.remove('is-active');
          });
          activeMedia.classList.add('is-active');
    
          if (this.featured) return;
    
          activeMedia.parentElement.prepend(activeMedia);
    
          window.setTimeout(() => {
            activeMedia.parentElement.scrollTo({
              left: 0,
              top: 0,
              behavior: 'smooth'
            });
          });
        }
      }
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      
      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          //if (text) submitButtonText.textContent = text;
          
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');
          //submitButtonText.textContent = window.theme.variantStrings.addToCart;
          if(this.currentVariant){
             //submitButtonText.textContent = window.theme.variantStrings.addToCart + " · "+current_currency+""+(this.currentVariant.price/100).toFixed(2);
          }
        }

      });
      const couponContainer = document.querySelector('coupon-container');
      if (couponContainer && couponContainer.resetPriceDom) {
        couponContainer.resetPriceDom();
      }
      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      /*
      let intervalQuick = setInterval(function(){
        $('#Product-Drawer-Content .single-add-to-cart-button').removeAttr('disabled');
      }, 100); 
      setTimeout(function() {
        clearInterval(intervalQuick);
      }, 2500);
      */
      const variant_data = this.getVariantData();


      if (variant_data) {
         var selected_options;
        if(this.currentVariant){
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index+1}`
            };
          });
        }else{
          let value1 = this.fieldsets[0].querySelector('select').value;
          this.currentVariant = variant_data.filter(function(variant_selected){
              if(variant_selected.option1 == value1){
                return variant_selected
              }
          });
          this.currentVariant = this.currentVariant[0];

          let selected_option2 = this.currentVariant.option2;
          if(selected_option2 && this.querySelector('.variant-container-item input[value="'+selected_option2+'"]')){
            this.querySelector('.variant-container-item input[value="'+selected_option2+'"]').click()
          }
          
           selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index+1}`
            };
          });
        }
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);


        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                // debugger
                if (option.isUnavailable) {
                  // fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
                input.classList.toggle('eam-is-hidden', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}
if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      const _this = this;
      const product_container = this.closest('.thb-product-detail');

      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');

      // Start Gallery
      this.addEventListener('change', this.setupProductGallery);
      this.setupProductGallery();

      // Start Pagination

      if (this.pagination) {
        this.setupPagination();
        this.addEventListener('scroll', this.updatePagination.bind(this));
        const resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
        resizeObserver.observe(this);
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      let activeImages = Array.from(this.querySelectorAll('.product-single__media-image'));

      this.setEventListeners(this, activeImages);
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    setEventListeners(container, activeImages) {
      let links = container.querySelectorAll('.product-single__media-zoom'),
        items = container.buildItems(activeImages),
        captionEl = container.dataset.captions,
        pswpElement = document.querySelectorAll('.pswp')[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true
        };

      links.forEach((link => {
        link.addEventListener('click', (event) => {
          let i = link.dataset.index;
          options.index = parseInt(i, 10);
          options.getThumbBoundsFn = () => {
            const thumbnail = link.closest('.product-single__media'),
              pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
              rect = thumbnail.getBoundingClientRect();
            return {
              x: rect.left,
              y: rect.top + pageYScroll,
              w: rect.width
            };
          };
          if (typeof PhotoSwipe !== 'undefined') {
            let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
            pswp.listen('firstUpdate', function() {
              pswp.listen('parseVerticalMargin', function(item) {
                item.vGap = {
                  top: 50,
                  bottom: 50
                };
              });
            });
            pswp.init();
          }
          event.preventDefault();
        });
      }));

    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');

      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');


      this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));

      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    updatePagination() {
      if (!this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
     redirectlocation(){
      window.location.href = "https://www.laifentech.com/cart";
    }
    onSubmitHandler(evt) {
      // redirectlocation();
      evt.preventDefault();
      if (!this.form.reportValidity()) {
        return;
      }
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });
      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.querySelector('.product-quick-images--container').classList.remove('active');
        document.body.classList.remove('open-quick-view');

        if (window.innerWidth < 1069) {
          product_drawer.classList.remove('active');
          if (document.getElementById('Cart-Drawer')) {
            document.getElementById('Cart-Drawer').classList.add('active');
            document.body.classList.add('open-cart');
            document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
            dispatchCustomEvent('cart-drawer:open');
          }
        } else {
          product_drawer.querySelector('.product-quick-images--container').addEventListener('transitionend', function() {
            product_drawer.classList.remove('active');

            if (document.getElementById('Cart-Drawer')) {
              document.getElementById('Cart-Drawer').classList.add('active');
              document.body.classList.add('open-cart');
              document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
              dispatchCustomEvent('cart-drawer:open');
            }
          });
        }

        if (!document.getElementById('Cart-Drawer')) {
          document.body.classList.remove('open-cc');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', function() {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function() {
          content.classList.toggle('active');
          return false;
        });
      }


    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function(entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}

if (!customElements.get("coupon-container")) {
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      console.log('===coupon-container', "connectedCallback");
      // console.log(this.getCouponData(),'===');
      this.getCouponData();
      this.initCode();
    }
    getCouponData () {
      return (
        (this.couponData = this.couponData || JSON.parse(this.querySelector('[type="application/json"]').textContent)), this.couponData
      );
    }
    initCode() {
      console.log('===coupon-container', "init");
      const { coupon_price, sale_type, coupon_code } = this.couponData;
      console.log(coupon_price, sale_type, coupon_code,'====');
      
      if (coupon_price && sale_type && coupon_code) {
        if (coupon_code) {
          fetch(`/discount/${coupon_code}`).then(async () => {
            console.log('===copy-code==success');
            this.resetPriceDom();
          }).catch(e => {
            console.log('===copy-code==error', e);
          });
        }
      }
    }
    resetPriceDom() {
      const { coupon_code, coupon_price, sale_type } = this.couponData;
      const price_container = document.querySelector('.product-price-container .price-backup');
      const money = Number(price_container.getAttribute('money')); // 分
      let save_price = 0;
      function floorToTwo(num) {
        return Math.floor(num * 100) / 100;
      }
      if (coupon_price && coupon_code) {
        if (sale_type === 'save_amount') {
          save_price = Number(coupon_price).toFixed(2);
        } else if (sale_type === 'save_percentage') {
          save_price = floorToTwo(money * coupon_price / 100 / 100).toFixed(2);
        }
        if(save_price > 0) {
          const savePriceDom = price_container.querySelector('.save-price');
          if (savePriceDom) {
            savePriceDom.textContent = `${currency}${save_price}`;
          } else {
            const save_dom = `<span class="badges">
                 <span class="badge onsale" style="margin-right: 10px;">with code save<p class="save-price">${currency}${save_price}</p></span>
            </span>`
            price_container.innerHTML = price_container.innerHTML + save_dom;
          }
        }
      }
    }
  }
  customElements.define("coupon-container", e);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}